import React, { useEffect } from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import BilateralSection from "../components/BilateralSection";
import BreathMoment from "../components/BreathMoment";
import RhythmChallenge from "../components/RhythmChallenge";
import DailyReflection from "../components/DailyReflection";
import Reframe from "../components/Reframe";
import CaseyStory from "../components/CaseyStory";
import Programs from "../components/Programs";
import Pricing from "../components/Pricing";
import PersonaGrid from "../components/PersonaGrid";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="grain">
      <Nav />
      <Hero />
      <BilateralSection />
      <RhythmChallenge />
      <BreathMoment />
      <DailyReflection />
      <Reframe />
      <CaseyStory />
      <Programs />
      <Pricing />
      <PersonaGrid />
      <Testimonials />
      <Footer />
    </div>
  );
}
